module.exports = __webpack_public_path__ + "static/media/Perugia.61f437ee.png";